<template>
	<div>
		<v-dialog v-model="showEdit" fullscreen persistent v-if="showEdit">
			<v-card>
				<v-toolbar dense color="primary" height="40" dark label="Nueva Programación">
					<h3>Programación de Cosecha</h3>
					<v-spacer></v-spacer>
					<div v-if="item">
						<v-btn fab class="elevation-0 mr-3" small color="primary" dark
							@click="$refs.edit.save()"><v-icon>mdi-content-save</v-icon></v-btn>
					</div>
					<v-btn v-else fab class="elevation-0 mr-3" small color="primary" dark
						@click="$refs.edit.save()"><v-icon>mdi-content-save</v-icon></v-btn>
					<v-btn fab class="elevation-0" small color="primary" dark @click="showEdit = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-container fluid class="mt-2">
					<HarvestScheduleEdit ref="edit" :objEdit="item" @close="closeEdit()" />
				</v-container>
			</v-card>
		</v-dialog>

		<v-container fluid>
			<v-row>
				<v-col lg="12" class="pt-2 pb-1">
					<s-crud @add="(item = null), (showEdit = true)" edit add-no-function add excel height="auto"
						searchInput ref="crud" @getFullData="getData($event)" @edit="editHvs($event)"
						title="Programación de Cosecha" :remove="selectedOne.HvsState == 0"
						@rowSelected="rowSelected($event)" :config="config" @save="save($event)"
						:filter="filterSchedule" no-full :show-group-by="true" :group-by="'VehPlate'">
						<!-- :single-row="false" -->
						<template v-slot:filter>
							<v-container class="pa-0 pb-3" dense fluid>
								<v-row justify="center" dense class="s-col-form">
									<v-col lg="3"><s-date label="Fecha Inicio"
											v-model="filterSchedule.HvsBeginDate"></s-date>
									</v-col>
									<v-col lg="3"><s-date label="Fecha Fin"
											v-model="filterSchedule.HvsEndDate"></s-date>
									</v-col>
									<v-col lg="3"><s-select-definition label="Cultivo" :def="1173"
											v-model="filterSchedule.TypeCultive" clearable />
									</v-col>
									<v-col lg="3"><s-select-definition label="Tipo Cultivo" :def="1172"
											v-model="filterSchedule.TypeCrop" clearable />
									</v-col>
								</v-row>
								<v-row justify="center" dense class="s-col-form">
									<v-col lg="3">
										<s-select-foreman autocomplete full clearable label="Capataz"
											v-model="filterSchedule.FrmID"></s-select-foreman>
									</v-col>
									<v-col lg="3">
										<s-select-supervice clearable label="Supervisor de Cosecha"
											v-model="filterSchedule.NtpSuperviceID" full></s-select-supervice>
									</v-col>
									<v-col lg="3">
										<s-select-supervice clearable label="Supervisor de fundo"
											v-model="filterSchedule.NtpSuperviceID2" full></s-select-supervice>
									</v-col>
									<v-col lg="3"><s-select-definition label="Destino" :def="1175"
											v-model="filterSchedule.TypeDestination" clearable />
									</v-col>

								</v-row>
							</v-container>
						</template>

						<template v-slot:ViewCert="{ row }">
							<v-btn x-small color="info" block outlined @click="clickView(row)">
								<v-icon style="font-size: 16px !important">fas fa-eye</v-icon>
							</v-btn>
						</template>

						<template v-slot:HvsStatusText="{ row }">
							<v-chip x-small :color="row.HvsStatus == 1 ? 'warning' : 'success'">{{ row.HvsStatusText
							}}</v-chip>
						</template>

						<template v-slot:HvsState="{ row }">
							<v-chip x-small :color="row.HvsState == 1 ? 'info' : 'error'">{{
								row.HvsState == 1
									? "Recepcionado"
									: "Sin Recepcionar"
							}}</v-chip>
						</template>

						<template v-slot:options>
							<v-tooltip bottom=""
								v-if="selectedHarvest.length == 1 && selectedOne.HvsID > 0 && $fun.hasSpecialPermission('AddVehicle')">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="openDialogAssignVehicles()" small>
										<i class="mdi mdi-truck"></i>
									</v-btn>
								</template>
								<span>Asignar Vehículos</span>
							</v-tooltip>

							<v-tooltip bottom="">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="createHarvestSchedule()" small>
										<i class="fas fa-layer-group"></i>
									</v-btn>
								</template>
								<span>Crear</span>
							</v-tooltip>


							<v-tooltip bottom="">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="showImportModal = true" small>
										<i class="fas fa-file-import"></i>
									</v-btn>
								</template>
								<span>Importar Excel</span>
							</v-tooltip>

							<v-tooltip bottom="" v-if="selectedHarvest.length > 0">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="openDialogGuide()" small>
										<i class="mdi mdi-note-text"></i>
									</v-btn>
								</template>
								<span>Guía Remisión</span>
							</v-tooltip>
						</template>

						<template v-slot:accion="{ row }">
							<v-checkbox v-model="selectedHarvestCheck" v-if="row.HvsStatus == 1" :value="row.HvsID"
								@click="addHarvestScheduleToCreate()" hide-details style="margin-top: -5px">

							</v-checkbox>
						</template>

						<!-- guia de remision -->
						<template v-slot:guidecheck="{ row }">
							<v-checkbox v-model="selectedGuideCheck" :value="row.HvsID"
								@click="addHarvestScheduleToCreate()" hide-details style="margin-top: -5px">

							</v-checkbox>
						</template>
					</s-crud>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-card>
						<v-container>
							<h2 style="display:inline;">Cantidad Jabas: </h2>
							<h2 style="display:inline;color:blue"> {{ this.totalDataRegist }}</h2>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- guias de remision previo-->
		<v-dialog v-if="dialogGuide" v-model="dialogGuide" persistent width="250">
			<s-toolbar label="Seleccione Guía" close @close="dialogGuide = false"></s-toolbar>
			<v-card>
				<v-container class="text-center">
					<v-col>
						<v-row align="center">
							<v-col class="s-col-form">
								<v-btn x-small color="primary" @click="openDialogGuideSelected(2)">
									Guía de Fruta
								</v-btn>
							</v-col>
						</v-row>
						<v-row align="center">
							<v-col class="s-col-form">
								<v-btn x-small color="success" @click="openDialogGuideSelected(3)">
									Guía de Material
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-container>
			</v-card>
		</v-dialog>

		<!-- guia de remiision seleccionada -->
		<v-dialog v-if="dialogGuideSelected" v-model="dialogGuideSelected">
			<!-- <s-toolbar
				label="Guía de Remisión"
				close
				@close="dialogGuideSelected = false"
			></s-toolbar> -->
			<!-- <fruit-guide
				v-if="guideSelected == 1"
				:HvsID="HvsID"
			></fruit-guide>
			<material-guide
				v-if="guideSelected == 2"
				:HvsID="HvsID"
			></material-guide> -->


			<lgs-referral-guide-edit :typeGuide="typeGuide" @closeDialogReferral="closeDialogReferral()"
				:referralGuideSelected="referralGuideSelected"></lgs-referral-guide-edit>
		</v-dialog>

		<v-dialog v-if="openDialogView" v-model="openDialogView" persistent style="display: contents" width="70%">
			<s-certification-lot :FltID="FltID" @close="closeCert()" />
		</v-dialog>

		<!-- Componente Modal de Importación -->
		<HarvestScheduleImportModal :show.sync="showImportModal" @close="showImportModalFunction"
			@dataLoaded="onDataLoaded" @validateCodSenasa="handleValidateCodSenasa" />


		<!-- Modal Unificado Asignación de Vehículos -->
		<v-dialog v-model="dialogAssignVehicles" max-width="1000px" transition="dialog-bottom-transition">
			<v-card class="elevation-4 rounded-xl overflow-hidden border-subtle" outlined elevation="0">
				<!-- Header Neutro Plano -->
				<div class="px-5 py-3 bg-white d-flex align-center justify-space-between border-subtle-bottom">
					<div class="d-flex align-center">
						<v-avatar color="grey lighten-4" size="38" class="mr-3">
							<v-icon color="grey darken-3">mdi-truck-delivery</v-icon>
						</v-avatar>
						<div>
							<h3 class="grey--text text--darken-4 text-h6 font-weight-black mb-0 lh-1">
								Asignación de Vehículos
							</h3>
							<span class="grey--text text--darken-2 text-caption"
								v-if="selectedOne && selectedOne.HvsID">
								ID Cosecha: <strong>#{{ selectedOne.HvsID }}</strong>
								| Productor: <strong> {{ displayProducerName }}</strong>
							</span>
						</div>
					</div>

					<!-- Resumen Jabas y Botón Cerrar -->
					<div class="d-flex align-center">
						<div class="d-flex align-center px-3 py-1 mr-3 rounded-lg border-subtle bg-light">
							<v-icon color="grey darken-3" class="">mdi-cube-outline</v-icon>
							<div class="d-flex flex-column text-right">
								<span class="text-h5 font-weight-black grey--text text--darken-4 lh-1">
									{{ totalJabasForemen.toLocaleString() }}
								</span>
								<span class="caption grey--text text--darken-2 font-weight-medium mt-1"
									style="font-size: 10px; line-height: 1;">Jabas</span>
							</div>
						</div>

						<v-btn icon small @click="dialogAssignVehicles = false">
							<v-icon small color="grey darken-2">mdi-close</v-icon>
						</v-btn>
					</div>
				</div>
				<v-divider></v-divider>

				<v-card-text class="pa-3 bg-light" style="max-height: 560px; overflow-y: auto;">
					<!-- Sección: Información del Lote de Fruta a Transportar -->
					<v-card class="pa-2 mb-2 rounded-xl border-subtle bg-white" outlined elevation="0"
						v-if="selectedOne">
						<div class="d-flex align-center justify-space-between mb-2">
							<div class="d-flex align-center">
								<v-icon color="grey darken-3" small class="mr-2">mdi-map-marker-radius</v-icon>
								<span class="subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
									Información del lote de fruta a transportar
								</span>
							</div>
						</div>

						<div class="d-flex align-center flex-wrap px-3 py-2 rounded-lg bg-light border-subtle"
							style="gap: 0;">
							<!-- Localidad -->
							<div class="d-flex flex-column mr-1">
								<span class="caption grey--text text--darken-1"
									style="font-size:10px; line-height:1;">Localidad</span>
								<span class="body-2 font-weight-bold grey--text text--darken-4"
									:title="displayLocality">
									{{ displayLocality || '—' }}
								</span>
							</div>
							<v-icon x-small color="grey lighten-1" class="mx-2">mdi-chevron-right</v-icon>
							<!-- Zona -->
							<div class="d-flex flex-column mr-1">
								<span class="caption grey--text text--darken-1"
									style="font-size:10px; line-height:1;">Zona</span>
								<span class="body-2 font-weight-bold grey--text text--darken-4" :title="displayZone">{{
									displayZone || '—' }}</span>
							</div>
							<v-icon x-small color="grey lighten-1" class="mx-2">mdi-chevron-right</v-icon>
							<!-- Sector -->
							<div class="d-flex flex-column mr-1">
								<span class="caption grey--text text--darken-1"
									style="font-size:10px; line-height:1;">Sector</span>
								<span class="body-2 font-weight-bold grey--text text--darken-4"
									:title="displaySector">{{
										displaySector || '—' }}</span>
							</div>
							<v-icon x-small color="grey lighten-1" class="mx-2">mdi-chevron-right</v-icon>
							<!-- SubSector -->
							<div class="d-flex flex-column mr-1">
								<span class="caption grey--text text--darken-1"
									style="font-size:10px; line-height:1;">SubSector</span>
								<span class="body-2 font-weight-bold grey--text text--darken-4"
									:title="displaySubSector">{{
										displaySubSector || '—' }}</span>
							</div>
							<template v-if="displayLotName && displayLotName !== 'No especificado'">
								<v-icon x-small color="grey lighten-1" class="mx-2">mdi-chevron-right</v-icon>
								<!-- Lote -->
								<div class="d-flex flex-column">
									<span class="caption grey--text text--darken-1"
										style="font-size:10px; line-height:1;">Lote</span>
									<span class="body-2 font-weight-bold grey--text text--darken-4"
										:title="displayLotName">{{
											displayLotName }}</span>
								</div>
							</template>
						</div>
					</v-card>

					<!-- Sección: Localidad y Zona de Pago -->
					<v-card class="pa-2 mb-4 rounded-xl border-subtle bg-white" outlined elevation="0">
						<div class="d-flex align-center justify-space-between mb-3">
							<div class="d-flex align-center">
								<v-icon color="grey darken-3" small class="mr-2">mdi-map-marker-check</v-icon>
								<span class="subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
									Localidad y Zona de Pago
								</span>
							</div>
						</div>

						<v-row dense class="align-center">
							<!-- Localidad -->
							<v-col cols="12" sm="4">
								<s-select-definition label="Localidad" :def="1253" v-model="selectedLocalityPayment"
									@input="onLocalityPaymentChange" clearable full></s-select-definition>
							</v-col>

							<!-- Zona de Pago -->
							<v-col cols="12" sm="4">
								<s-select label="Zona de Pago" :items="zonesPaymentList" item-text="ZonName"
									item-value="ZonID" v-model="selectedZonePayment" autocomplete clearable full
									:disabled="loadingZonesPayment" placeholder="Seleccione zona de pago"></s-select>
							</v-col>
						</v-row>
					</v-card>

					<!-- Sección 1: Vehículos de Capataces -->
					<v-card class="pa-2 mb-4 rounded-xl border-subtle bg-white" outlined elevation="0">
						<div class="d-flex align-center justify-space-between mb-3">
							<div class="d-flex align-center">
								<v-icon color="grey darken-3" small class="mr-2">mdi-account-truck</v-icon>
								<span class="subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
									1. Vehículos de Capataces
								</span>
							</div>
							<v-chip x-small color="grey lighten-3" text-color="grey darken-3" class="font-weight-bold"
								v-if="foremenAssignList.length > 0">
								{{ foremenAssignList.length }} Capataz(ces)
							</v-chip>
						</div>

						<v-progress-linear v-if="loadingForemanVehicles" indeterminate color="grey darken-2" height="2"
							class="mb-2"></v-progress-linear>

						<v-data-table v-if="foremenAssignList.length > 0" dense hide-default-footer :headers="[
							{ text: 'Capataz', value: 'Worker', sortable: false },
							{ text: 'Lote', value: 'FltName', sortable: false },
							{ text: 'Placa Material', value: 'VehPlate', width: '180px', sortable: false },
							{ text: 'Capacidad', value: 'Capacity', width: '100px', sortable: false },
							{ text: 'Conductor', value: 'DriverName', width: '240px', sortable: false }
						]" :items="foremenAssignList" class="elevation-0 border-subtle rounded-lg">
							<template v-slot:item.Worker="{ item }">
								<span class="body-2 font-weight-bold grey--text text--darken-4 d-flex align-center">
									<v-icon small color="grey darken-3" class="mr-1">mdi-account-hard-hat</v-icon>
									{{ item.Worker || item.FrmName || 'Sin nombre' }}
								</span>
							</template>
							<template v-slot:item.FltName="{ item }">
								<div class="d-flex align-center">
									<span class="caption font-weight-medium grey--text text--darken-4 d-flex align-center">
										<v-icon x-small color="grey darken-3" class="mr-1">mdi-sprout-outline</v-icon>
										{{ item.FltName || '—' }}
									</span>
									<span v-if="item.HvsQuantityMaterial" class="caption grey--text text--darken-2 ml-1">
										({{ item.HvsQuantityMaterial }} jabas)
									</span>
								</div>
							</template>
							<template v-slot:item.VehPlate="{ item }">
								<div v-if="!item.VehPlate" class="py-1" style="min-width: 170px;">
									<s-select-transport return-object :value="item.ObjTransport"
										v-model="item.ObjTransport"
										@input="onSelectTransportForeman(item, $event)" full
										clearable placeholder="Seleccionar placa" />
								</div>
								<div v-else class="py-1">
									<div class="d-flex align-center">
										<span class="body-2 font-weight-bold grey--text text--darken-4 d-flex align-center">
											<v-icon x-small color="grey darken-3" class="mr-1">mdi-truck</v-icon>
											{{ item.VehPlate }}
										</span>
										<v-btn icon x-small class="ml-1 grey--text text--darken-1"
											@click="clearForemanVehicle(item)" title="Cambiar placa">
											<v-icon style="font-size: 14px;">mdi-pencil-outline</v-icon>
										</v-btn>
									</div>
								</div>
							</template>
							<template v-slot:item.Capacity="{ item }">
								<span v-if="item.ObjTransport && (item.ObjTransport.CfvCapacityMin || item.ObjTransport.CfvCapacity)"
									class="caption grey--text text--darken-4 font-weight-bold">
									<span v-if="item.ObjTransport.CfvCapacityMin && item.ObjTransport.CfvCapacity && item.ObjTransport.CfvCapacityMin !== item.ObjTransport.CfvCapacity">
										{{ item.ObjTransport.CfvCapacityMin }} - {{ item.ObjTransport.CfvCapacity }}
									</span>
									<span v-else>
										{{ item.ObjTransport.CfvCapacity || item.ObjTransport.CfvCapacityMin }}
									</span>
								</span>
								<span v-else class="caption grey--text text--darken-2">
									—
								</span>
							</template>
							<template v-slot:item.DriverName="{ item }">
								<div class="py-1" style="min-width: 170px;">
									<s-select-driver clearable full :value="item.DriverName" v-model="item.DriverName"
										@input="onDriverForemanChange(item, $event)" placeholder="Seleccionar conductor" />
								</div>
							</template>
						</v-data-table>
						<div v-else-if="!loadingForemanVehicles" class="text-center py-3 mb-2">
							<span class="caption grey--text text--darken-2 font-italic">
								No hay capataces asignados en esta programación
							</span>
						</div>
					</v-card>

					<!-- Sección 2: Transporte de Fruta -->
					<v-card class="pa-2 rounded-xl border-subtle bg-white" outlined elevation="0">
						<div class="d-flex align-center mb-3">
							<v-icon color="grey darken-3" small class="mr-2">mdi-truck-fast</v-icon>
							<span class="subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
								2.Transporte de Fruta
							</span>
						</div>

						<v-progress-linear v-if="loadingFruitVehicles" indeterminate color="grey darken-2" height="2"
							class="mb-2"></v-progress-linear>

						<v-data-table v-if="fruitTransportList.length > 0" dense hide-default-footer :headers="[
							{ text: 'Placa', value: 'TptEnrollment', width: '180px', sortable: false },
							{ text: 'Capacidad', value: 'TptTon', width: '130px', sortable: false },
							{ text: 'Vehículo', value: 'TptVehicle', width: '100px', sortable: false },
							{ text: 'Chofer', value: 'TptDriver', sortable: false },
						]" :items="fruitTransportList" class="elevation-0 border-subtle rounded-lg">
							<template v-slot:item.TptEnrollment="{ item }">
								<div v-if="!item.TptEnrollment" class="py-1" style="min-width: 170px;">
									<s-select-transport return-object :value="item.ObjTransport"
										v-model="item.ObjTransport"
										@input="onSelectFruitTransport(item, $event)" full
										clearable placeholder="Seleccionar placa" />
								</div>
								<div v-else class="py-1">
									<div class="d-flex align-center">
										<span class="body-2 font-weight-bold grey--text text--darken-4 d-flex align-center">
											<v-icon x-small color="grey darken-3" class="mr-1">mdi-truck</v-icon>
											{{ item.TptEnrollment }}
										</span>
										<v-btn icon x-small class="ml-1 grey--text text--darken-1"
											@click="clearFruitVehicle(item)" title="Cambiar placa">
											<v-icon style="font-size: 14px;">mdi-pencil-outline</v-icon>
										</v-btn>
									</div>
								</div>
							</template>
							<template v-slot:item.TptVehicle="{ item }">
								<span class="caption grey--text text--darken-3 font-weight-medium">
									{{ (item.ObjTransport && item.ObjTransport.DedDescription) || item.TptVehicle || '—' }}
								</span>
							</template>
							<template v-slot:item.TptDriver="{ item }">
								<div class="py-1" style="min-width: 170px;">
									<s-select-driver clearable full :value="item.TptDriver" v-model="item.TptDriver"
										@input="onDriverFruitChange(item, $event)" placeholder="Seleccionar chofer" />
								</div>
							</template>
							<template v-slot:item.TptTon="{ item }">
								<span v-if="item.ObjTransport && (item.ObjTransport.CfvCapacityMin || item.ObjTransport.CfvCapacity)"
									class="caption grey--text text--darken-4 font-weight-bold">
									<span v-if="item.ObjTransport.CfvCapacityMin && item.ObjTransport.CfvCapacity && item.ObjTransport.CfvCapacityMin !== item.ObjTransport.CfvCapacity">
										{{ item.ObjTransport.CfvCapacityMin }} - {{ item.ObjTransport.CfvCapacity }}
									</span>
									<span v-else>
										{{ item.ObjTransport.CfvCapacity || item.ObjTransport.CfvCapacityMin }}
									</span>
								</span>
								<span v-else class="caption grey--text text--darken-3 font-weight-medium">
									{{ item.TptTon ? item.TptTon + ' Ton' : '—' }}
								</span>
							</template>
						</v-data-table>
						<div v-else-if="!loadingFruitVehicles" class="text-center py-3">
							<span class="caption grey--text text--darken-2 font-italic">
								No hay información de transporte de fruta
							</span>
						</div>
					</v-card>

				</v-card-text>

				<v-divider></v-divider>
				<v-card-actions class="px-5 py-3 bg-white d-flex justify-end">
					<v-btn small color="error" elevation="0" class="px-3 py-2 text-none font-weight-bold rounded-lg"
						@click="dialogAssignVehicles = false">Cancelar</v-btn>
					<v-btn small color="primary" elevation="0" class="px-3 py-2 text-none font-weight-bold rounded-lg"
						@click="saveAssignVehiclesAll()">
						<!-- <v-icon left small>mdi-check-circle-outline</v-icon> -->
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import _sFarm from "@/services/Technicalassistance/AgriculturalFarmsService";
import _sHarvest from "@/services/Technicalassistance/HarvestSchedule";
import _sHarvestGuide from "@/services/Technicalassistance/HarvestScheduleGuideService";
import _sReceptionSurveillance from "@/services/Technicalassistance/ReceptionSurveillanceService";
import _sTasGroupZonService from "@/services/Technicalassistance/TasGroupZonService";
import _sDefinition from "@/services/General/DefinitionService";
import _sZone from "@/services/Technicalassistance/ZoneService";

import _sParameter from "@/services/General/ParameterService.js";

import SCertificationLot from "@/components/TecnicalAssistence/sCertificationLot.vue";
import TableMaterial from "@/components/HarvestSchedule/TableMaterial.vue";
import TableCarrier from "@/components/HarvestSchedule/TableCarrier.vue";
import TableForeman from "@/components/HarvestSchedule/TableForeman.vue";
import SSelectForeman from "@/components/HarvestSchedule/SSelectForeman";
import SSelectSupervice from "@/components/HarvestSchedule/SSelectSupervice";
import _sAlertHistoryService from "@/services/FreshProduction/AlertHistoryService";
import HarvestScheduleEdit from "@/views/TechnicalAssistance/HarvestSchedule/HarvestScheduleEdit.vue";
import FruitGuide from './GuideReferral/FruitGuide.vue';
import MaterialGuide from './GuideReferral/MaterialGuide.vue';
import LgsReferralGuideEdit from '@/views/Logistics/ReferralGuide/LgsReferralGuideEdit.vue';
import _sVehicle from "@/services/Management/VehicleService";
import SSelectFarm from "@/components/HarvestSchedule/SSelectFarm";
import SSelectTransport from "@/components/HarvestSchedule/SSelectTransport";
import SSelectDriver from "@/components/HarvestSchedule/sSelectDriver.vue";
import sSelectedZona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedZona";
import HarvestScheduleImportModal from "@/components/HarvestSchedule/HarvestScheduleImportModal.vue";
import _sCertificationsService from "@/services/Technicalassistance/CertificationsService";

export default {
	components: {
		TableMaterial,
		TableCarrier,
		SSelectForeman,
		TableForeman,
		SSelectSupervice,
		HarvestScheduleEdit,
		SCertificationLot,
		FruitGuide,
		MaterialGuide,
		LgsReferralGuideEdit,
		HarvestScheduleImportModal,
		SSelectTransport,
		SSelectDriver,
		SSelectFarm,
		sSelectedZona,
	},
	props: {},
	data: () => ({
		showImportModal: false,
		selectedGuideCheck: [],
		typeGuide: 0,
		referralGuideSelected: {},
		dialogGuide: false,
		dialogGuideSelected: false,
		guideSelected: 0,
		openDialogView: false,
		totalDataRegist: 0,
		selectedHarvestCheck: [],
		selectedHarvest: [],
		showEdit: false,
		item: null,
		FagIDg: 0,
		ZonDescription: "",
		SzoDescription: "",
		min: 0,
		FagAddress: "",
		VrtDescription: "",
		listTableMaterial: [], //carlos
		TypeCultive: 0, //carlos
		validateMaterial: false, //carlos
		TypeLoad: 0, //carlos
		FagName: "", //carlos
		TypeCrop: 0, //carlos
		TypeCultiveText: "",
		TypeCropText: "",
		itemsForeman: [],
		dataByCodSenasa: [],
		dataTableTransport: [],
		ObjAgriculturalFarm: [],
		HvsID: 0,
		HvsStatus: 0,
		typeCharge: 0,
		itemsFarm: [],
		itemsLots: [],
		searchSenasaActive: false,
		itemsTransport: [],
		ObjFundo: [],
		objFltID: null,
		itemsCapataz: [],
		ObjSupervice: null,
		ObjProducer: { PrdID: -1 },
		itemsMaterial: [],
		isEdit: false,
		forSearch: true,
		filterSchedule: { BeginDate: null, EndDate: null },
		selectedOne: {},
		config: {
			model: {
				HvsID: "ID",
				HvsDate: "date",
				HvsStatusText: "",
				HvsStatus: "",
				HvsState: "",
				accion: "",
				ViewCert: "",
				guidecheck: ""
			},
			service: _sHarvest,
			headers: [
				{ text: "Guía R", value: "guidecheck", width: 70 },
				{ text: "View", value: "ViewCert", width: 70 },
				{ text: "Accion", value: "accion", width: 10 },
				{ text: "ID", value: "HvsID", width: 10 },
				// { text: "Estado", value: "HvsStatus", width: 10 },
				{ text: "Estado", value: "HvsStatusText", width: 10 },
				{ text: "Fecha", value: "HvsDate" },
				{ text: "Cod.Senasa", value: "FagCodeSenasa", width: 100 },
				{ text: "Fundo", value: "FagName", width: 280 },
				{ text: "Lote", value: "FltName", width: 80 },
				{ text: "Cantidad Jaba", value: "AmountTotalJaba" },
				{ text: "Productor", value: "PrdText", width: 450 },
				{ text: "Tipo Servicio", value: "TypeServiceText" },
				{ text: "Procedencia", value: "TypeOriginText", width: 150 },
				{ text: "Cultivo", value: "TypeCultiveText" },
				{ text: "Variedad", value: "VrtDescription" },
				{ text: "Tipo Cultivo", value: "TypeCropText" },
				{ text: "Tipo de Cosecha", value: "TypeHarvestName" },
				{ text: "Destino", value: "TypeDestinationText", width: 100 },
				{ text: "Planta Procesadora", value: "TypeProcessingPlantText" },
				{ text: "Empacadora", value: "TypeBalerText" },
				{ text: "Placa Fruta", value: "VehPlate" },
				{ text: "Placa Materiales", value: "VehPlateMaterials" },
				{ text: "", value: "HvsState" },
				/* { text: "Productor", value: "PrdText", width: 250 }, */

				/* { text: "Lote", value: "FltName", width: 250 }, */
			],
		},
		HvsID: 0,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: []
		},
		certifications: [],
		allCertifications: [],
		hasRainforest: null,

		dialogAssignVehicles: false,
		loadingForemanVehicles: false,
		loadingFruitVehicles: false,
		availableVehicles: [],
		availableDrivers: [],
		loadingDrivers: false,
		loadDriversPromise: null,
		foremenAssignList: [],
		fruitTransportList: [],
		deletedFruitTransports: [],
		VehPlateFruitInput: "",
		typeLoadFruit: 1,
		loadingFarmDetails: false,
		farmExtraDetails: null,
		selectedLocalityPayment: null,
		selectedZonePayment: null,
		zonesPaymentList: [],
		loadingZonesPayment: false,
	}),
	computed: {
		displayFarmName() {
			return (this.selectedOne && this.selectedOne.FagName) || (this.farmExtraDetails && this.farmExtraDetails.FagName) || 'No especificado';
		},
		displayProducerName() {
			return (this.selectedOne && this.selectedOne.PrdText) || (this.farmExtraDetails && (this.farmExtraDetails.PrdText || this.farmExtraDetails.PrdCardName)) || 'No especificado';
		},
		displayLotName() {
			return (this.selectedOne && this.selectedOne.FltName) || (this.farmExtraDetails && this.farmExtraDetails.FltName) || 'No especificado';
		},
		displaySenasaCode() {
			return (this.selectedOne && this.selectedOne.FagCodeSenasa) || (this.farmExtraDetails && (this.farmExtraDetails.FagCodeSenasa || this.farmExtraDetails.FltCodSenasa)) || '-';
		},
		displayZone() {
			return (this.selectedOne && (this.farmExtraDetails && (this.farmExtraDetails.ZonIDText))) || '-';

			// return (this.selectedOne && (this.selectedOne.ZonDescription || this.selectedOne.ZonIDText || this.selectedOne.Zona)) ||
			// 	(this.farmExtraDetails && (this.farmExtraDetails.ZonIDText || this.farmExtraDetails.ZonDescription)) || '-';
		},
		displaySector() {
			return (this.selectedOne && (this.selectedOne.StrDescription || this.selectedOne.StrIDText || this.selectedOne.Sector)) ||
				(this.farmExtraDetails && (this.farmExtraDetails.StrDescription || this.farmExtraDetails.StrIDText || this.farmExtraDetails.SstrDescription)) || '-';
		},
		displayLocality() {
			return (this.selectedOne && (this.farmExtraDetails && (this.farmExtraDetails.TypeZoneName))) || '-';
		},
		displaySubSector() {
			return (this.selectedOne && (this.selectedOne.SstrDescription || this.selectedOne.SstrIDText || this.selectedOne.SubSector)) ||
				(this.farmExtraDetails && (this.farmExtraDetails.SstrDescription || this.farmExtraDetails.SstrIDText)) ||
				(this.selectedOne && (this.selectedOne.SzoDescription || this.selectedOne.SzoIDText || this.selectedOne.SubZona)) ||
				(this.farmExtraDetails && (this.farmExtraDetails.SzoIDText || this.farmExtraDetails.SzoDescription)) || '-';
		},
		displaySubZone() {
			return (this.selectedOne && (this.selectedOne.SzoDescription || this.selectedOne.SzoIDText || this.selectedOne.SubZona)) ||
				(this.farmExtraDetails && (this.farmExtraDetails.SzoIDText || this.farmExtraDetails.SzoDescription)) || '';
		},
		totalJabasForemen() {
			if (this.foremenAssignList && this.foremenAssignList.length > 0) {
				const sum = this.foremenAssignList.reduce((acc, item) => {
					const qty = Number(item.HvsQuantityMaterial || item.MtrQuantity || item.QuantityMaterial || item.Jabas || 0);
					return acc + (isNaN(qty) ? 0 : qty);
				}, 0);
				if (sum > 0) return sum;
			}
			return Number(this.selectedOne?.AmountTotalJaba || this.selectedOne?.HvsQuantity || 0);
		},
		displayAddress() {
			return (this.selectedOne && this.selectedOne.FagAddress) || (this.farmExtraDetails && this.farmExtraDetails.FagAddress) || '';
		},
		displayCropVariety() {
			const cultive = (this.selectedOne && this.selectedOne.TypeCultiveText) || (this.farmExtraDetails && this.farmExtraDetails.TypeCultiveText) || '';
			const crop = (this.selectedOne && this.selectedOne.TypeCropText) || (this.farmExtraDetails && this.farmExtraDetails.TypeCropText) || '';
			const variety = (this.selectedOne && this.selectedOne.VrtDescription) || (this.farmExtraDetails && this.farmExtraDetails.VrtDescription) || '';
			const parts = [cultive, crop, variety].filter(Boolean);
			return parts.length > 0 ? parts.join(' • ') : '-';
		},
		displayTotalJabas() {
			return (this.selectedOne && (this.selectedOne.AmountTotalJaba || this.selectedOne.HvsQuantity)) || 0;
		},
		displayTypeCharge() {
			if (this.selectedOne && this.selectedOne.TypeChargeText) return this.selectedOne.TypeChargeText;
			if (this.selectedOne && this.selectedOne.TypeCharge) {
				return this.selectedOne.TypeCharge == 1 ? 'Jabas' : (this.selectedOne.TypeCharge == 2 ? 'Bines' : 'Carga #' + this.selectedOne.TypeCharge);
			}
			return 'Jabas';
		}
	},
	methods: {

		handleValidateCodSenasa(data) {
			console.log('Validando Cod Senasa:', data.codSenasa);
			// Validar Cod Senasa usando el servicio de granjas
			const objSenasa = {
				CodSenasa: data.codSenasa,
				FagID: 0,
			};

			_sFarm.listFarm(objSenasa, this.$fun.getUserID()).then((response) => {
				console.log('Respuesta validando Senasa:', response);
				if (response.data && response.data.length > 0) {
					// Senasa válido
					data.callback({ isValid: true, data: response.data[0] });
				} else {
					// Senasa no encontrado
					data.callback({ isValid: false, data: null });
				}
			}).catch((error) => {
				console.error('Error validando Senasa:', error);
				data.callback({ isValid: false, data: null });
			});
		},

		onDataLoaded(data) {
			// Este método se ejecuta cuando se cargan datos del Excel
			console.log('Datos cargados del Excel:', data);
			// Aquí procesarás los datos cargados
		},

		closeDialogReferral() {
			this.dialogGuideSelected = false;
		},
		openDialogGuide() {
			if (this.selectedHarvest.length > 0) {
				this.dialogGuide = true;
			}
		},

		openDialogGuideSelected(value) {
			this.guideSelected = value;
			this.dialogGuide = false;

			if (this.selectedGuideCheck.length > 1 && value == 2) {
				this.$fun.alert("Debe de seleccionar solo un registro", "warning");
				return;
			}

			//samir
			this.typeGuide = value;
			let detail = [];
			let counter = 0;
			//fruta
			if (value == 2) {
				this.referralGuideSelected.VehPlate = this.selectedOne.VehPlate?.trim();
				this.referralGuideSelected.PrsDocumentNumberDriver = this.selectedOne.PrsDocumentNumberDriver?.trim();
				this.referralGuideSelected.NpdLastNameDriver = this.selectedOne.NpdLastNameDriver?.trim();
				this.referralGuideSelected.NpdNameDrive = this.selectedOne.NpdNameDrive?.trim();
				this.referralGuideSelected.NpdDocumentNumberDriver = this.selectedOne.NpdDocumentNumberDriver;

				let objParam = {
					PrmName: "MOTIVOGUIAFRUTA"
				};

				_sParameter
					.search(objParam, this.$fun.getUserID())
					.then((r) => {
						this.referralGuideSelected.RegOtherMotive = r.data.PrmValue.toUpperCase();

					});
				counter++;

				let countDocumentNumber = this.selectedOne.PrdDocumentNumber?.length;
				let typeDocumentNumber = countDocumentNumber > 8 ? "RUC: " : "DNI: ";

				let RgdDescriptionMsIQF = this.selectedOne.TypeCultiveText + ' ' + this.selectedOne.TypeCropText.toUpperCase() + " PARA INDUSTRIA, VARIEDAD: " + this.selectedOne.VrtDescription.toUpperCase() + ', PROVEEDOR: ' + this.selectedOne.PrdText + ', ID: ' + this.selectedOne.FltID;
				let RgdDescriptionMsFRESH = this.selectedOne.TypeCultiveText + " FRESCO PARA EXPORTACIÓN, TIPO " + this.selectedOne.TypeCropText.toUpperCase() + ", VARIEDAD: " + this.selectedOne.VrtDescription.toUpperCase() + ', FUNDO: ' + this.selectedOne.FagName + ', COD-SENASA: ' + this.selectedOne.FagCodeSenasa + ', ' + typeDocumentNumber + this.selectedOne.PrdDocumentNumber + ' ID: ' + this.selectedOne.FltID;

				let RgdTotal = this.selectedOne.HvsQuantity * 20;

				detail.push({
					RgdLine: counter,
					DocEntry: 0,
					// RgdDescription: this.selectedOne.TypeCultiveText + " " + this.selectedOne.TypeCropText + " Variedad: " 
					// + this.selectedOne.VrtDescription.toUpperCase() 
					// + " Proveedor: " + this.selectedOne.PrdText
					// + " ID: " + this.selectedOne.FltID,
					RgdDescription: this.selectedOne.TypeDestination == 1 ? RgdDescriptionMsFRESH : RgdDescriptionMsIQF,
					RgdQuantity: this.selectedOne.HvsQuantity,
					RgdTotal: RgdTotal,
					RgdUnitMeasurement: "UND",
					TypeUnitMeasurement: 4,
					SecStatus: 1,
					UsrCreateID: this.$fun.getUserID(),
					TypeDetail: 1
				});
			}
			//materiales
			if (value == 3) {
				this.referralGuideSelected.VehPlate = this.selectedOne.VehPlateForeman;
				this.referralGuideSelected.PrsDocumentNumberDriver = this.selectedOne.PrsDocumentNumberDriverForeman;
				this.referralGuideSelected.NpdLastNameDriver = this.selectedOne.NpdLastNameDriverForeman;
				this.referralGuideSelected.NpdNameDrive = this.selectedOne.NpdNameDriverForeman;
				this.referralGuideSelected.NpdDocumentNumberDriver = this.selectedOne.NpdDocumentNumberDriverForeman;

				let objParam = {
					PrmName: "MOTIVOMATERIALES"
				};

				_sParameter
					.search(objParam, this.$fun.getUserID())
					.then((r) => {
						this.referralGuideSelected.RegOtherMotive = r.data.PrmValue.toUpperCase();;

					});

				let stringHvsID = this.selectedGuideCheck.join();

				//load material
				_sHarvestGuide.materialreferralguide(stringHvsID, this.$fun.getUserID()).then((r) => {
					if (r.status == 200) {
						console.log("lista de materiales", r.data)
						r.data.details.forEach(element => {
							counter++;
							detail.push({
								RgdLine: counter,
								DocEntry: 0,
								RgdDescription: element.MtrMaterial,
								RgdQuantity: element.MtrQuantity,
								RgdTotal: element.MtrNetWeight,
								RgdUnitMeasurement: "UND",
								SecStatus: 1,
								UsrCreateID: this.$fun.getUserID(),
								TypeDetail: 1
							});
						});

						// Calcular netWeight después de llenar el array detail
						let netWeight = detail.reduce((sum, item) => sum + (item.RgdTotal || 0), 0);

						this.referralGuideSelected.RegGrossWeightCargo = netWeight; // O el cálculo que necesites
						this.referralGuideSelected.RegNetWeightCargo = netWeight;
					}
				});
			}
			counter = 0;
			console.log("guia seleccionadoa ", this.selectedOne);

			let netWeight = detail.reduce((sum, item) => sum + (item.RgdTotal || 0), 0);
			let grossWeight = this.selectedOne.HvsQuantity * 21.7;

			this.referralGuideSelected.RegAddressStartPoint =
				this.selectedOne.FagAddress?.trim() +
				(this.selectedOne.FagUbigeoFundName ? ' - ' + this.selectedOne.FagUbigeoFundName : '');


			// this.referralGuideSelected.NpdFullNameDriver = this.selectedOne.NpdFullNameDriver.trim();

			this.referralGuideSelected.TypeAreGuide = 2;
			this.referralGuideSelected.DocEntry = this.selectedOne.HvsID;
			this.referralGuideSelected.TypeUnitMeasurement = 3;
			this.referralGuideSelected.RegGrossWeightCargo = grossWeight;
			this.referralGuideSelected.RegNetWeightCargo = netWeight;

			this.referralGuideSelected.FagUbigeoFundName = this.selectedOne.FagUbigeoFundName;
			this.referralGuideSelected.UbgDepartament = this.selectedOne.UbgDepartament;
			this.referralGuideSelected.UbgProvince = this.selectedOne.UbgProvince;
			this.referralGuideSelected.UbgDistrict = this.selectedOne.UbgDistrict;
			this.referralGuideSelected.DepUbigeoFarm = this.selectedOne.DepUbigeoFarm;
			this.referralGuideSelected.ProUbigeoFarm = this.selectedOne.ProUbigeoFarm;
			this.referralGuideSelected.DisUbigeoFarm = this.selectedOne.DisUbigeoFarm;

			this.referralGuideSelected.referralGuideItems = detail;

			let objParam = {
				VehPlate: this.referralGuideSelected.VehPlate?.trim()
			}

			_sVehicle
				.SearchVehPlate(objParam, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.referralGuideSelected.RegConstancyInscripcionTransport = resp.data.RegistrationConstancy;
						this.referralGuideSelected.RegBrandTransport = resp.data.TypeVehicleBrandName;
						this.referralGuideSelected.RegRucTransport = resp.data.VehRuc;
						this.referralGuideSelected.RegBusinessNameTransport = resp.data.VehBusinessName;
					}
				});

			console.log("destino", this.referralGuideSelected);
			console.log("destinos", this.selectedOne);

			const filter = {
				FltID: this.selectedOne.FltID,
			};

			const paginationParams = {
				filter: filter,
				draw: 1,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				length: this.options.itemsPerPage,
				order: [],
				searchText: '',
			};

			if (this.options.sortBy.length > 0) {
				paginationParams.order = [{
					column: this.options.sortBy[0],
					dir: this.options.sortDesc[0] ? 'desc' : 'asc'
				}];
			}
			this.referralGuideSelected.RegObservation = "";
			_sCertificationsService.pagination(paginationParams, this.$fun.getUserID())
				.then((resp) => {
					console.log("certifications", resp.data.data);
					this.certifications = resp.data.data[0];

					this.allCertifications = resp.data.data;

					// Verificar si existe alguna certificación Rainforest
					this.hasRainforest = this.allCertifications.some(cert =>
						cert.TypeCertificationText &&
						cert.TypeCertificationText.toUpperCase().includes('RAINFOREST')
					);
				})
				.catch((error) => {
					this.certifications = null;
				})
				.finally(() => {
					// Este código se ejecuta SIEMPRE, haya error o no
					if (value === 2) {
						if (this.selectedOne.TypeDestination === 2) {
							let observacion = 'FUNDO: ' + this.selectedOne.FagName.toUpperCase();

							// Solo agregar certificación si existe
							if (this.certifications) {
								observacion += ' - Certificación: ' + this.certifications.TypeCertificationText.toUpperCase();
							}

							if (this.selectedOne.FagCodeSenasa) {
								observacion += ' - Código de Senasa: ' + this.selectedOne.FagCodeSenasa;
							}

							observacion += ' - VAN ' + this.selectedOne.HvsQuantity + ' JABAS DE MANGO PARA INDUSTRIA';

							this.referralGuideSelected.RegObservation = observacion;
						} else {
							let observacion = 'HORA DE SALIDA:            ';

							if (this.certifications) {
								observacion += ' - MANGO CERTIFICADO ' + this.certifications.TypeCertificationText.toUpperCase() + ' - GGN ' + this.certifications.CrtNumberCertificate;

								if (this.hasRainforest) {
									observacion += ' - MANGO RAINFOREST ALLIANCE CERTIFIED';
								}
							}

							observacion += ' - VAN ' + this.selectedOne.HvsQuantity + ' JABAS.';

							this.referralGuideSelected.RegObservation = observacion;
						}
					}

					this.referralGuideSelected.TypeDestination = this.selectedOne.TypeDestination;
					this.referralGuideSelected.FagName = this.selectedOne.FagName;

					this.dialogGuideSelected = true;
				});

			this.dialogGuideSelected = true;
		},

		clickView(val) {
			this.FltID = val.FltID;
			this.openDialogView = true;
		},

		closeCert() {
			this.openDialogView = false;
		},

		getData(item) {
			this.totalDataRegist = 0;
			item.data.forEach((x) => {
				this.totalDataRegist += x.AmountTotalJaba;
			});

		},
		addHarvestScheduleToCreate(item) {
			console.log('arr ', this.selectedHarvestCheck);
		},

		async createHarvestSchedule() {
			this.$fun.alert("¿Seguro de crear?", "question").then(r => {
				if (r.value) {
					let countRespo = 0;
					let countSelectedHarvest = this.selectedHarvest.length;
					this.selectedHarvestCheck.forEach(element => {
						_sHarvest.groupcreate(element, this.$fun.getUserID()).then(resp => {
							if (resp.status == 200) {
								console.log('entro');
								this.$fun.alert("Creadas correctamente", "success");
								this.$refs.crud.refresh();
								countRespo = countRespo + 1;
							}
						})
					});
					//this.filterSchedule.BeginDate = new Date();

					/* console.log('countRespo ', countRespo);
					console.log('countSelectedHarvest ', countSelectedHarvest);
					if(countRespo == countSelectedHarvest){
						this.$fun.alert("Creadas correctamente", "success");
					}
					else{
						this.$fun.alert("Ocurrio un error al crear programaciones", "error");
					} */
				}
			})
		},

		editHvs(item) {
			this.showEdit = true;
			this.item = item;
		},
		closeEdit() {
			this.showEdit = false;
			this.$refs.crud.refresh();
		},
		change() {
			this.forSearch = false;
		},

		input(item) {
			item.FagID = this.ObjAgriculturalFarm.FagID;
			item.FagAddress = this.ObjAgriculturalFarm.FagAddress;
			this.FagName = item.FagName;
			if (this.ObjAgriculturalFarm.FagID != undefined) {
				this.FagIDg = this.ObjAgriculturalFarm.FagID;
			}
		},

		emitTableTransport(item) {
			this.dataTableTransport = item;
		},

		dataItemsForeman(dataItemsForeman) {
			this.itemsForeman = dataItemsForeman;
		},

		dblclick(item) {
			this.PrdID = item.PrdID;
			this.TypeCultiveText = item.TypeCultiveText;
			this.TypeCropText = item.TypeCropText;
			this.FagName = item.FagName;
			this.dataByCodSenasa = item;
			this.VrtDescription = item.VrtDescription;
			this.FagAddress = item.FagAddress;
			this.ZonDescription = item.ZonIDText;
			this.SzoDescription = item.SzoIDText;
			//this.forSearch = false;
		},

		InputTypeCharge(item) {
			this.TypeLoad = item;
			this.typeCharge = item;
		},
		//SELECCIONA FUNDOS
		inputFarm(FagID, item) {
			if (this.searchSenasaActive) return;
			if (FagID == null) {
				this.itemsLots = [];
				return;
			}
			_sHarvest.listLote(FagID, 0, "", this.$fun.getUserID()).then(r => {
				this.itemsLots = r.data;
				item.ZonID = this.itemsLots[0].ZonDescription;
				item.SzoID = this.itemsLots[0].SzoDescription;
				if (this.itemsLots.length > 0)
					if (item.FltID == 0 || item.FltID == null || item.FltID == "")
						this.objFltID = this.itemsLots[0];
					else {
						this.objFltID = this.itemsLots.find(
							x => x.FltID == item.FltID,
						);
					}
			});
		},
		//SELECCIONA FUNDOS

		//Programar Transporte
		rowSelected(item) {
			this.selectedHarvest = item;

			if (item !== null) {
				if (item.length > 0) {
					this.selectedOne = item[0]
					this.FltID = this.selectedOne.FltID;
					this.HvsID = item[0].HvsID;
					console.log('ssss ', this.FltID);
				}

			}

		},

		inputTableListMaterial(listTableMaterial) {
			this.listTableMaterial = listTableMaterial;
		},
		save(item) {
			if (this.dataTableTransport.length == 0) {
				this.$fun.alert("Ingresar Transporte ", "warning");
				return;
			}
			this.itemsForeman.forEach(element => {
				if (!element.PrdID) {
					this.$fun.alert("Ingrese productor", "warning");
				}
			});

			item.TypeCrop = this.dataByCodSenasa.TypeCrop;
			item.VrtID = this.dataByCodSenasa.VrtID;
			item.TypeCultive = this.dataByCodSenasa.TypeCultive;
			item.ZonID = this.dataByCodSenasa.ZonID;
			item.SzoID = this.dataByCodSenasa.SzoID;
			item.GenSuperviceID = this.ObjSupervice.NtpSuperviceID;
			item.FagID = this.dataByCodSenasa.FagID;
			item.FagAddress = this.dataByCodSenasa.FagAddress;
			item.DetailsGenForeman = this.itemsForeman;
			item.DetailsTransport = this.dataTableTransport;


			console.log("cosecha a guardar samir", item);
			return;

			item.save();
		},

		assignMaterialCultive(item) {
			this.TypeCultive = item;
		},
		showImportModalFunction() {
			this.showImportModal = false;
			this.$refs.crud.refresh();
		},

		openDialogAssignVehicles() {
			if (this.selectedHarvest.length !== 1 || !this.selectedOne || !this.selectedOne.HvsID) {
				this.$fun.alert("Debe seleccionar solo un registro", "warning");
				return;
			}
			this.foremenAssignList = [];
			this.fruitTransportList = [];
			this.deletedFruitTransports = [];
			this.VehPlateFruitInput = "";
			this.typeLoadFruit = 1;
			this.loadingForemanVehicles = true;
			this.loadingFruitVehicles = true;
			this.loadingFarmDetails = true;
			this.farmExtraDetails = null;
			this.selectedLocalityPayment = null;
			this.selectedZonePayment = null;
			this.zonesPaymentList = [];
			this.dialogAssignVehicles = true;

			// Cargar datos complementarios del fundo si se dispone de FltID o FagCodeSenasa o FagID
			const searchCode = (this.selectedOne.FltID || this.selectedOne.FagCodeSenasa || '').toString();
			if (searchCode || this.selectedOne.FagID) {
				const params = {
					CodSenasa: searchCode,
					FagID: this.selectedOne.FagID || 0,
					Date: this.selectedOne.HvsDate || this.$fun.getDate()
				}

				_sFarm.listFarm(params, this.$fun.getUserID()).then(res => {
					this.loadingFarmDetails = false;
					if (res && res.data && res.data.length > 0) {
						const found = res.data.find(x => x.FltID == this.selectedOne.FltID) || res.data[0];
						this.farmExtraDetails = found;
					}
					this.initLocalityAndZoneDefaults();
				}).catch(() => {
					this.loadingFarmDetails = false;
					this.initLocalityAndZoneDefaults();
				});
			} else {
				this.loadingFarmDetails = false;
				this.initLocalityAndZoneDefaults();
			}

			// Cargar catálogo de conductores para autoasignación
			this.availableDrivers = [];
			this.loadingDrivers = true;
			this.loadDriversPromise = _sReceptionSurveillance.listDriver("", this.$fun.getUserID())
				.then(r => {
					if (r && r.status == 200 && r.data) {
						this.availableDrivers = r.data;
					}
				})
				.catch(err => {
					console.error("Error al cargar lista de conductores:", err);
				})
				.finally(() => {
					this.loadingDrivers = false;
				});

			// Cargar catálogo de vehículos para capacidades e información
			_sHarvest.listTransport(0, "", this.$fun.getUserID()).then(rTrans => {
				if (rTrans && rTrans.status == 200 && rTrans.data) {
					this.availableVehicles = rTrans.data;
					if (this.foremenAssignList && this.foremenAssignList.length > 0) {
						this.foremenAssignList.forEach(f => {
							if (f.VehPlate && !f.ObjTransport) {
								const found = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === f.VehPlate.toUpperCase());
								if (found) {
									this.$set(f, 'ObjTransport', found);
								}
							}
						});
					}
					if (this.fruitTransportList && this.fruitTransportList.length > 0) {
						this.fruitTransportList.forEach(item => {
							if (item.TptEnrollment && !item.ObjTransport) {
								const found = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === item.TptEnrollment.trim().toUpperCase());
								if (found) {
									this.$set(item, 'ObjTransport', found);
								}
							}
						});
					}
				}
			}).catch(() => { });

			// Cargar Capataces
			_sHarvest.listGenForemanS(this.selectedOne.HvsID).then(resp => {
				this.loadingForemanVehicles = false;
				if (resp && resp.status == 200 && resp.data) {
					this.foremenAssignList = resp.data.map(item => {
						const plate = (item.VehPlate || '').trim();
						let objTrans = null;
						if (plate && this.availableVehicles && this.availableVehicles.length > 0) {
							objTrans = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === plate.toUpperCase()) || null;
						}
						return {
							...item,
							GfrID: item.GfrID || item.GfrId || 0,
							GenForemanID: item.GenForemanID || item.FrmID,
							Worker: item.Worker || item.FrmName || 'Sin nombre',
							VehPlate: plate,
							ObjTransport: objTrans,
							DriverName: (item.DriverName || '').trim(),
							NtpIDDriver: item.NtpIDDriver || null,
							VehPlateSecondary: (item.VehPlateSecondary || '').trim(),
							NtpIDDriverSecondary: item.NtpIDDriverSecondary || null,
							HvsQuantityPerson: item.HvsQuantityPerson || 0,
							HvsQuantityMaterial: item.HvsQuantityMaterial || 0
						};
					});

					// Complementar con GetGang si ya se había registrado recepción previa
					_sReceptionSurveillance.GetGang({ HvsID: this.selectedOne.HvsID }, this.$fun.getUserID()).then(rGang => {
						if (rGang && rGang.status == 200 && rGang.data && rGang.data.length > 0) {
							this.foremenAssignList.forEach(f => {
								const match = rGang.data.find(g => (g.GngID && g.GngID === f.GfrID) || (g.FrmID && g.FrmID === f.GenForemanID));
								if (match) {
									if (!f.VehPlate && match.VehPlate) {
										f.VehPlate = match.VehPlate.trim();
										if (this.availableVehicles && this.availableVehicles.length > 0) {
											const found = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === f.VehPlate.toUpperCase());
											if (found) this.$set(f, 'ObjTransport', found);
										}
									}
									if (!f.DriverName && match.DriverName) f.DriverName = match.DriverName.trim();
									if (!f.VehPlateSecondary && match.VehPlateSecondary) f.VehPlateSecondary = match.VehPlateSecondary.trim();
									if (!f.NtpIDDriver && match.NtpIDDriver) f.NtpIDDriver = match.NtpIDDriver;
								}
							});
						}
					}).catch(() => { });
				}
			}).catch(() => {
				this.loadingForemanVehicles = false;
			});

			// Cargar Transporte de Fruta desde ReceptionSurveillance (Datos de Vehículo - Fruta)
			_sReceptionSurveillance.GetTransport({ HvsID: this.selectedOne.HvsID }, this.$fun.getUserID()).then(resp => {
				this.loadingFruitVehicles = false;
				if (resp && resp.status == 200 && resp.data && resp.data.length > 0) {
					const fruitOnly = resp.data.filter(x => !x.TypeLoad || x.TypeLoad == 1);
					const list = fruitOnly.length > 0 ? fruitOnly : resp.data;
					if (list.length > 0) {
						this.fruitTransportList = [list[0]].map(element => {
							const plate = (element.TptEnrollment || '').trim();
							let objTrans = null;
							if (plate && this.availableVehicles && this.availableVehicles.length > 0) {
								objTrans = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === plate.toUpperCase()) || null;
							}
							return {
								TptId: element.TptId || 0,
								RcsTptID: element.RcsTptID || 0,
								HvsID: element.HvsID || this.selectedOne.HvsID,
								TptEnrollment: plate,
								ObjTransport: objTrans,
								TptVehicle: element.TptVehicle || '',
								TptDriver: element.TptDriver || '',
								TptTon: element.TptTon || 0,
								TypeLoad: element.TypeLoad || 1,
								TypeLoadName: element.TypeLoadName || 'Fruta',
								SecStatus: 1,
								UsrCreateID: element.UsrCreateID || this.$fun.getUserID(),
								UsrUpdateID: this.$fun.getUserID()
							};
						});
					} else {
						this.fruitTransportList = [{
							TptId: 0,
							RcsTptID: 0,
							HvsID: this.selectedOne.HvsID,
							TptEnrollment: '',
							ObjTransport: null,
							TptVehicle: '',
							TptDriver: '',
							TptTon: 0,
							TypeLoad: (this.selectedOne ? this.selectedOne.TypeCharge : 0) || 1,
							TypeLoadName: 'Fruta',
							SecStatus: 1,
							UsrCreateID: this.$fun.getUserID(),
							UsrUpdateID: this.$fun.getUserID()
						}];
					}
				} else {
					// Fallback a listProducerS si GetTransport no trajo registros
					_sHarvest.listProducerS(this.selectedOne.HvsID).then(r => {
						if (r && r.status == 200 && r.data && r.data.length > 0) {
							this.fruitTransportList = [r.data[0]].map(element => {
								const plate = (element.TptEnrollment || '').trim();
								let objTrans = null;
								if (plate && this.availableVehicles && this.availableVehicles.length > 0) {
									objTrans = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === plate.toUpperCase()) || null;
								}
								return {
									TptId: element.TptId || 0,
									HvsID: element.HvsID || this.selectedOne.HvsID,
									TptEnrollment: plate,
									ObjTransport: objTrans,
									TptVehicle: element.TptVehicle || '',
									TptDriver: element.TptDriver || '',
									TptTon: element.TptTon || 0,
									TypeLoad: element.TypeLoad || 1,
									SecStatus: 1,
									UsrCreateID: element.UsrCreateID || this.$fun.getUserID(),
									UsrUpdateID: this.$fun.getUserID()
								};
							});
						} else {
							this.fruitTransportList = [{
								TptId: 0,
								RcsTptID: 0,
								HvsID: this.selectedOne.HvsID,
								TptEnrollment: '',
								ObjTransport: null,
								TptVehicle: '',
								TptDriver: '',
								TptTon: 0,
								TypeLoad: (this.selectedOne ? this.selectedOne.TypeCharge : 0) || 1,
								TypeLoadName: 'Fruta',
								SecStatus: 1,
								UsrCreateID: this.$fun.getUserID(),
								UsrUpdateID: this.$fun.getUserID()
							}];
						}
					});
				}
			}).catch(() => {
				this.loadingFruitVehicles = false;
				_sHarvest.listProducerS(this.selectedOne.HvsID).then(resp => {
					if (resp && resp.status == 200 && resp.data && resp.data.length > 0) {
						this.fruitTransportList = [resp.data[0]].map(element => {
							const plate = (element.TptEnrollment || '').trim();
							let objTrans = null;
							if (plate && this.availableVehicles && this.availableVehicles.length > 0) {
								objTrans = this.availableVehicles.find(v => v.VehPlate && v.VehPlate.trim().toUpperCase() === plate.toUpperCase()) || null;
							}
							return {
								TptId: element.TptId || 0,
								HvsID: element.HvsID || this.selectedOne.HvsID,
								TptEnrollment: plate,
								ObjTransport: objTrans,
								TptVehicle: element.TptVehicle || '',
								TptDriver: element.TptDriver || '',
								TptTon: element.TptTon || 0,
								TypeLoad: element.TypeLoad || 1,
								SecStatus: 1,
								UsrCreateID: element.UsrCreateID || this.$fun.getUserID(),
								UsrUpdateID: this.$fun.getUserID()
							};
						});
					} else {
						this.fruitTransportList = [{
							TptId: 0,
							RcsTptID: 0,
							HvsID: this.selectedOne.HvsID,
							TptEnrollment: '',
							ObjTransport: null,
							TptVehicle: '',
							TptDriver: '',
							TptTon: 0,
							TypeLoad: (this.selectedOne ? this.selectedOne.TypeCharge : 0) || 1,
							TypeLoadName: 'Fruta',
							SecStatus: 1,
							UsrCreateID: this.$fun.getUserID(),
							UsrUpdateID: this.$fun.getUserID()
						}];
					}
				});
			});
		},

		addEmptyFruitTransport() {
			let objPlate = {
				TptId: 0,
				RcsTptID: 0,
				HvsID: this.selectedOne ? this.selectedOne.HvsID : 0,
				TptEnrollment: '',
				TptVehicle: '',
				TptDriver: '',
				TptTon: 0,
				TypeLoad: (this.selectedOne ? this.selectedOne.TypeCharge : 0) || 1,
				TypeLoadName: 'Fruta',
				SecStatus: 1,
				UsrCreateID: this.$fun.getUserID(),
				UsrUpdateID: this.$fun.getUserID()
			};
			this.fruitTransportList.push(objPlate);
		},

		addFruitTransport(valor) {
			if (!valor || !valor.item) return;
			let plate = valor.item.VehPlate;
			let validatePlate = false;

			this.fruitTransportList.forEach(element => {
				if (element.TptEnrollment === plate && element.SecStatus === 1) {
					validatePlate = true;
					this.$fun.alert("Placa ya agregada", "warning");
				}
			});

			if (!validatePlate) {
				let objPlate = {
					TptId: 0,
					HvsID: this.selectedOne ? this.selectedOne.HvsID : 0,
					TptEnrollment: valor.item.VehPlate,
					TptVehicle: valor.item.TypeVehicleBrandName || valor.item.TypeVehicleText || '',
					TptDriver: valor.item.Driver || '',
					TptTon: valor.item.CfvCapacity || 0,
					TypeLoad: (this.selectedOne ? this.selectedOne.TypeCharge : 0) || 1,
					SecStatus: 1,
					UsrCreateID: this.$fun.getUserID(),
					UsrUpdateID: this.$fun.getUserID()
				};
				this.fruitTransportList.push(objPlate);
			}
		},

		removeFruitTransport(item, index) {
			if (item.TptId > 0) {
				this.deletedFruitTransports.push({
					...item,
					SecStatus: 0,
					UsrUpdateID: this.$fun.getUserID()
				});
			}
			this.fruitTransportList.splice(index, 1);
		},

		findDriverForVehicle(val) {
			if (!val) return null;
			if (this.availableDrivers && this.availableDrivers.length > 0) {
				// 1. Buscar por DNI del conductor (NumDocDriver con AdvDriverDNI)
				if (val.NumDocDriver) {
					const dni = String(val.NumDocDriver).trim();
					const byDni = this.availableDrivers.find(d => d.AdvDriverDNI && String(d.AdvDriverDNI).trim() === dni);
					if (byDni) return byDni;
				}
				// 2. Buscar por nombre del conductor (Conductor con DriverName normalizado)
				if (val.Conductor) {
					const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toUpperCase();
					const targetName = norm(val.Conductor);
					const byName = this.availableDrivers.find(d => norm(d.DriverName) === targetName);
					if (byName) return byName;
				}
			}
			return null;
		},

		async onSelectTransportForeman(fItem, val) {
			console.log("Cambio de placa material:", val);
			if (val && typeof val === 'object') {
				this.$set(fItem, 'ObjTransport', val);
				this.$set(fItem, 'ObjTransportTemp', val);
				this.$set(fItem, 'VehPlate', (val.VehPlate || '').trim());

				if (this.loadDriversPromise) {
					try {
						await this.loadDriversPromise;
					} catch (e) { }
				}

				let matched = this.findDriverForVehicle(val);
				if (matched) {
					this.$set(fItem, 'DriverName', matched.DriverName);
					this.$set(fItem, 'NtpIDDriver', matched.NtpID);
				} else if (val.Conductor) {
					this.$set(fItem, 'DriverName', val.Conductor.trim());
					this.$set(fItem, 'NtpIDDriver', val.PrsID || null);
				}
			} else if (typeof val === 'string' && val) {
				this.$set(fItem, 'VehPlate', val.trim());
			} else {
				this.clearForemanVehicle(fItem);
			}
		},

		onDriverForemanChange(fItem, val) {
			if (val && typeof val === 'object') {
				this.$set(fItem, 'DriverName', (val.DriverName || '').trim());
				this.$set(fItem, 'NtpIDDriver', val.NtpID || null);
			} else if (typeof val === 'string') {
				this.$set(fItem, 'DriverName', val.trim());
				if (this.availableDrivers && this.availableDrivers.length > 0) {
					const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toUpperCase();
					const target = norm(val);
					const found = this.availableDrivers.find(d => norm(d.DriverName) === target);
					if (found) this.$set(fItem, 'NtpIDDriver', found.NtpID || null);
				}
			} else {
				this.$set(fItem, 'DriverName', '');
				this.$set(fItem, 'NtpIDDriver', null);
			}
		},

		async onSelectFruitTransport(item, val) {
			console.log("Cambio de placa fruta:", val);
			if (val && typeof val === 'object') {
				this.$set(item, 'ObjTransport', val);
				this.$set(item, 'TptEnrollment', (val.VehPlate || '').trim());
				this.$set(item, 'TptVehicle', val.DedDescription || item.TptVehicle || '');
				this.$set(item, 'TptTon', (val.CfvCapacity !== undefined && val.CfvCapacity !== null) ? val.CfvCapacity : (val.TptTon || 0));

				if (this.loadDriversPromise) {
					try {
						await this.loadDriversPromise;
					} catch (e) { }
				}

				let matched = this.findDriverForVehicle(val);
				if (matched) {
					this.$set(item, 'TptDriver', matched.DriverName);
					this.$set(item, 'NtpIDDriver', matched.NtpID);
				} else if (val.Conductor) {
					this.$set(item, 'TptDriver', val.Conductor.trim());
					this.$set(item, 'NtpIDDriver', val.PrsID || null);
				}
			} else if (typeof val === 'string' && val) {
				this.$set(item, 'TptEnrollment', val.trim());
			} else {
				this.clearFruitVehicle(item);
			}
		},

		onDriverFruitChange(item, val) {
			if (val && typeof val === 'object') {
				this.$set(item, 'TptDriver', (val.DriverName || '').trim());
				this.$set(item, 'NtpIDDriver', val.NtpID || null);
			} else if (typeof val === 'string') {
				this.$set(item, 'TptDriver', val.trim());
				if (this.availableDrivers && this.availableDrivers.length > 0) {
					const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toUpperCase();
					const target = norm(val);
					const found = this.availableDrivers.find(d => norm(d.DriverName) === target);
					if (found) this.$set(item, 'NtpIDDriver', found.NtpID || null);
				}
			} else {
				this.$set(item, 'TptDriver', '');
				this.$set(item, 'NtpIDDriver', null);
			}
		},

		clearFruitVehicle(item) {
			this.$set(item, 'TptEnrollment', '');
			this.$set(item, 'ObjTransport', null);
		},

		clearForemanVehicle(fItem) {
			this.$set(fItem, 'VehPlate', '');
			this.$set(fItem, 'ObjTransport', null);
			this.$set(fItem, 'ObjTransportTemp', null);
		},

		selectForemanVehicle(fItem, event) {
			if (event && event.item) {
				this.onSelectTransportForeman(fItem, event.item);
			}
		},

		saveAssignVehiclesAll() {
			if (!this.selectedOne || !this.selectedOne.HvsID) {
				this.$fun.alert("Seleccione un registro", "warning");
				return;
			}

			this.$fun.alert("¿Seguro de guardar la asignación?", "question")
				.then(r => {
					if (r.value) {
						// Formatear Capataces
						let updatedForemen = this.foremenAssignList.map(item => {
							let vehPlate = (item.VehPlate || (item.ObjTransport && item.ObjTransport.VehPlate) || (item.ObjTransportTemp && item.ObjTransportTemp.VehPlate) || '').trim();
							let driverName = (item.DriverName || (item.ObjTransport && (item.ObjTransport.Driver || item.ObjTransport.DriverName || item.ObjTransport.Conductor)) || (item.ObjTransportTemp && (item.ObjTransportTemp.Driver || item.ObjTransportTemp.DriverName || item.ObjTransportTemp.Conductor)) || '').trim();
							let ntpIdDriver = item.NtpIDDriver || (item.ObjTransport && (item.ObjTransport.NtpIDDriver || item.ObjTransport.PrsID)) || (item.ObjTransportTemp && item.ObjTransportTemp.NtpIDDriver) || null;
							let vehPlateSecondary = (item.VehPlateSecondary || '').trim();

							return {
								GfrID: item.GfrID || item.GfrId || 0,
								HvsID: this.selectedOne.HvsID,
								GenForemanID: item.GenForemanID || item.FrmID,
								FltID: item.FltID || this.selectedOne.FltID,
								PrdID: item.PrdID || this.selectedOne.PrdID,
								HvsQuantityPerson: item.HvsQuantityPerson || 0,
								HvsQuantityMaterial: item.HvsQuantityMaterial || 0,
								VehPlate: vehPlate,
								DriverName: driverName,
								NtpIDDriver: ntpIdDriver,
								NtpIDDriverSecondary: item.NtpIDDriverSecondary || null,
								VehPlateSecondary: vehPlateSecondary,
								SecStatus: 1,
								UsrCreateID: this.$fun.getUserID()
								// UsrUpdateID: this.$fun.getUserID()
							};
						});

						// Formatear Transporte de Fruta
						let transports = this.fruitTransportList
							.filter(t => t.TptEnrollment || t.TptId > 0)
							.map(t => ({
								TptId: t.TptId || 0,
								HvsID: this.selectedOne.HvsID,
								TptEnrollment: (t.TptEnrollment || '').trim(),
								TptVehicle: (t.TptVehicle || '').trim(),
								TptDriver: (t.TptDriver || '').trim(),
								TptTon: (t.TptTon !== undefined && t.TptTon !== null) ? t.TptTon.toString() : '0',
								TypeLoad: t.TypeLoad || 1,
								SecStatus: t.TptEnrollment ? 1 : 0,
								UsrCreateID: this.$fun.getUserID()
								// UsrUpdateID: this.$fun.getUserID()
							}));

						let newHvsStatus = (this.fruitTransportList.some(t => !!t.TptEnrollment)) ? 2 : 1;

						let payload = {
							HvsID: this.selectedOne.HvsID,
							CmpID: this.selectedOne.CmpID || 1,
							HvsDate: this.selectedOne.HvsDate || this.$fun.getDate(),
							TypeService: this.selectedOne.TypeService || 1,
							TypeOrigin: this.selectedOne.TypeOrigin || 1,
							TypeCharge: this.selectedOne.TypeCharge || 1,
							TypeCultive: this.selectedOne.TypeCultive || 1,
							TypeCrop: this.selectedOne.TypeCrop || 1,
							TypeDestination: this.selectedOne.TypeDestination || 1,
							TypeProcessingPlant: this.selectedOne.TypeProcessingPlant || 1,
							TypeBaler: this.selectedOne.TypeBaler || 0,
							FagID: this.selectedOne.FagID || 0,
							FltID: this.selectedOne.FltID || 0,
							VrtID: this.selectedOne.VrtID || 0,
							PrdID: this.selectedOne.PrdID || 0,
							Observation: this.selectedOne.Observation || '',
							HvsQuantity: this.selectedOne.HvsQuantity || 0,
							HvsStatus: newHvsStatus.toString(),
							SecStatus: 1,
							GenSuperviceID: this.selectedOne.GenSuperviceID || 0,
							TypeEntryMerchandise: this.selectedOne.TypeEntryMerchandise || null,
							HvsAttach: this.selectedOne.HvsAttach || null,
							TypeNegociation: this.selectedOne.TypeNegociation || null,
							TypeMode: this.selectedOne.TypeMode || null,
							TypePriceCategory: this.selectedOne.TypePriceCategory || null,
							TypeUnitJaba: this.selectedOne.TypeUnitJaba || null,
							IncludesMaterialsJaba: this.selectedOne.IncludesMaterialsJaba !== undefined ? this.selectedOne.IncludesMaterialsJaba : null,
							TypeUnitMaterials: this.selectedOne.TypeUnitMaterials || null,
							TypeUnitPersonnelTransportation: this.selectedOne.TypeUnitPersonnelTransportation || null,
							ObservationTypeUnit: this.selectedOne.ObservationTypeUnit || null,
							UsrCreateID: this.$fun.getUserID(),
							// UsrUpdateID: this.$fun.getUserID(),
							DetailsGenForeman: updatedForemen,
							DetailsTransport: transports,
							TypeZonePayment: this.selectedLocalityPayment || null,
							ZonIDPayment: this.selectedZonePayment || null,
							RcsPaymentZone: this.selectedZonePayment || null
						};



						if (this.selectedLocalityPayment) {
							this.selectedOne.TypeZonePayment = this.selectedLocalityPayment;
						}
						if (this.selectedZonePayment) {
							this.selectedOne.ZonIDPayment = this.selectedZonePayment;
							this.selectedOne.RcsPaymentZone = this.selectedZonePayment;
						}

						_sHarvest.save(payload, this.$fun.getUserID()).then(r => {
							if (r && r.status == 200) {
								this.$fun.alert("Asignación de vehículos guardada correctamente", "success");
								this.dialogAssignVehicles = false;
								if (this.$refs.crud) {
									this.$refs.crud.refresh();
								}
							}
						}).catch(err => {
							let msg = (err.response && err.response.data && (err.response.data.Message || err.response.data)) || err.message;
							this.$fun.alert("Error al guardar asignación: " + msg, "error");
						});
					}
				});
		},

		async initLocalityAndZoneDefaults() {
			this.loadingZonesPayment = true;
			try {

				this.selectedLocalityPayment = (this.selectedOne.TypeZonePayment) || (this.farmExtraDetails && (this.farmExtraDetails.TypeZone)) || null;
				await this.loadZonesPayment(this.selectedLocalityPayment);
				this.selectedZonePayment = this.selectedOne.ZonIDPayment || (this.farmExtraDetails && (this.farmExtraDetails.ZonID)) || null;

			} catch (e) {
				console.error("Error al inicializar localidad y zona de pago:", e);
			} finally {
				this.loadingZonesPayment = false;
			}
		},

		onLocalityPaymentChange(val) {
			this.selectedLocalityPayment = val;
			this.selectedZonePayment = null;
			this.loadZonesPayment(val);
		},

		async loadZonesPayment(localityID) {
			this.loadingZonesPayment = true;
			try {
				let zones = [];
				if (localityID) {
					const resp = await _sTasGroupZonService.GetZonesByGroup({ TypeZon: localityID }, this.$fun.getUserID());
					zones = (resp && resp.status == 200 && resp.data) ? resp.data : [];
				} else {
					const resp = await _sZone.listzon("", this.$fun.getUserID());
					zones = (resp && resp.status == 200 && resp.data) ? resp.data : [];
				}
				this.zonesPaymentList = zones.map(z => ({
					...z,
					ZonID: z.ZonID,
					ZonName: z.ZonName || z.ZonDescription || z.DefName || '',
					ZonDescription: z.ZonDescription || z.ZonName || ''
				}));
			} catch (err) {
				console.error("Error cargando zonas por localidad:", err);
				this.zonesPaymentList = [];
			} finally {
				this.loadingZonesPayment = false;
			}
		}

	},
	created() { },
};
</script>

<style scoped>
.opacity-80 {
	opacity: 0.85;
}

.bg-light {
	background-color: #f8fafc;
}

.border-subtle {
	border: 1px solid #e2e8f0;
}

.border-subtle-bottom {
	border-bottom: 1px solid #e2e8f0;
}

.border-dashed {
	border: 2px dashed #cbd5e1;
}

.lh-1 {
	line-height: 1.2;
}

.h-100 {
	height: 100%;
}
</style>
